/* @refresh reload */
import { render } from "solid-js/web";

import { Login } from "./components/Login";

const root = document.getElementById("root");
if (root) {
    render(() => <Login/>, root);
}

